import React from 'react';
import { Calendar, FileText, ArrowRight } from 'lucide-react';
import { doctorProfile } from '../data/mockData';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            <span>Accepting New Patients</span>
          </div>
          
          <h1 className="hero-title">
            {doctorProfile.name}
          </h1>
          
          <p className="hero-subtitle">
            {doctorProfile.title}
          </p>
          
          <p className="hero-credentials">
            {doctorProfile.credentials}
          </p>
          
          <p className="hero-tagline">
            {doctorProfile.tagline}
          </p>
          
          <div className="hero-cta-group">
            <button onClick={() => scrollToSection('booking')} className="hero-cta-primary">
              <Calendar size={20} />
              Schedule Consultation
            </button>
            <button onClick={() => scrollToSection('about')} className="hero-cta-secondary">
              <FileText size={20} />
              Professional Profile
              <ArrowRight size={16} />
            </button>
          </div>
        </div>
        
        <div className="hero-image-wrapper">
          <div className="hero-image-card">
            <img src={doctorProfile.image} alt={doctorProfile.name} className="hero-image" />
            <div className="hero-image-overlay"></div>
          </div>
          <div className="floating-card experience-card">
            <div className="floating-card-number">{doctorProfile.experience}+</div>
            <div className="floating-card-label">Years of Excellence</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
